<template>
  <div class="addvolunteercon" :class="{'pc': !isPhone}">
    <pcheader v-show="!isPhone"></pcheader>
    <el-form ref="volunteer" :model="dataForm" :rules="datarules" label-position="top" style="width: 100%;">
      <div class="container">
        <div class="additem">
          <h2 class="pubtitle">预约人信息</h2>
          <ul class="personul">
            <li>
              <div class="lileft"><i class="icon-name"></i><span>姓名</span></div>
              <el-form-item class="" prop="realName">
                <el-input v-model="dataForm.realName" placeholder="请输入" @blur.prevent="blurFun()"/>
              </el-form-item>
            </li>
            <li>
              <div class="lileft"><i class="icon-place"></i><span>身份证</span></div>
              <el-form-item class="" prop="identityCard">
                <el-input v-model="dataForm.identityCard" placeholder="请输入" @blur.prevent="blurFun()"/>
              </el-form-item>
            </li>
            <li>
              <div class="lileft"><i class="icon-sex"></i><span>性别</span></div>
              <el-form-item class="" prop="sex">
                <el-select v-model="dataForm.sex" placeholder="男">
                  <el-option value="男"></el-option>
                  <el-option value="女"></el-option>
                </el-select>
              </el-form-item>
            </li>
            <li>
              <div class="lileft"><i class="icon-email"></i><span>邮箱</span></div>
              <el-form-item class="" prop="email">
                <el-input v-model="dataForm.email" placeholder="请输入" @blur.prevent="blurFun()"/>
              </el-form-item>
            </li>
            <li>
              <div class="lileft"><i class="icon-school"></i><span>学校/单位</span></div>
              <el-form-item class="" prop="school">
                <el-input v-model="dataForm.school" placeholder="请输入" @blur.prevent="blurFun()"/>
              </el-form-item>
            </li>
            <li>
              <div class="lileft"><i class="icon-major"></i><span>专业</span></div>
              <el-form-item class="" prop="major">
                <el-input v-model="dataForm.major" placeholder="请输入" @blur.prevent="blurFun()"/>
              </el-form-item>
            </li>
            <li>
              <div class="lileft"><i class="icon-place"></i><span>籍贯</span></div>
              <el-form-item class="" prop="place">
                <el-input v-model="dataForm.place" placeholder="请输入" @blur.prevent="blurFun()"/>
              </el-form-item>
            </li>
          </ul>
        </div>
        <div class="additem">
          <h2 class="pubtitle" @click="popshow(0)">志愿者经历<i></i></h2>
        </div>
        <div class="additem">
          <h2 class="pubtitle" @click="popshow(1)">个人技能<i></i></h2>
        </div>
        <div class="pop" ref="pop">
          <div class="popbox">
            <div class="popinner">
              <div class="content" :class="{on: ispopindex == 0}">
                <div class="title">志愿者经历</div>
                <div class="con">
                  <el-form-item prop="experience">
                    <el-input v-model="dataForm.experience" type="textarea" placeholder="请输入" @blur.prevent="blurFun()"/>
                    <div class="el-form-item__error" v-if="exshow">志愿者经历不能为空</div>
                  </el-form-item>
                </div>
                <div class="pubbutton" @click.stop="experiencefun"><span>确定</span></div>
              </div>
              <div class="content" :class="{on: ispopindex == 1}">
                <div class="title">个人技能</div>
                <div class="con">
                  <el-form-item prop="skill">
                    <el-input v-model="dataForm.skill" type="textarea" placeholder="请输入" @blur.prevent="blurFun()"/>
                    <div class="el-form-item__error" v-if="skillshow">个人技能不能为空</div>
                  </el-form-item>
                </div>
                <div class="pubbutton" @click.stop="skillfun"><span>确定</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pubbutton" @click.stop="confirmbtn" :class="{disabled: isdisabled}"><span>提交</span></div>
      </div>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
import Pcheader from '@/views/common/pcheader'
export default {
  name: 'volunteerinfo',
  components: {
    Pcheader
  },
  data () {
    return {
      dataForm: {
        realName: '',
        sex: '',
        email: '',
        school: '',
        major: '',
        place: '',
        experience: '',
        skill: '',
        identityCard: ''
      },
      datarules: {
        realName: [{required: true, message: '姓名不能为空', trigger: 'blur'}, {min: 1, max: 100, message: '长度不能超过100个字符', trigger: 'blur'}],
        sex: [{required: true, message: '请选择性别', trigger: 'blur'}],
        email: [{required: true, message: '邮箱不能为空', trigger: 'blur'}, { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }],
        school: [{required: true, message: '学校/单位不能为空', trigger: 'blur'}],
        major: [{required: true, message: '专业不能为空', trigger: 'blur'}],
        place: [{required: true, message: '籍贯不能为空', trigger: 'blur'}],
        phoneNumber: [{required: true, message: '请输入手机号', trigger: 'blur'}, {pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, message: '手机号格式不对', trigger: 'blur'}],
        experience: [{required: true, message: '志愿者经历不能为空', trigger: 'blur'}],
        skill: [{required: true, message: '个人技能不能为空', trigger: 'blur'}],
        identityCard: [{required: true, message: '请输入身份证号', trigger: 'blur'}, {pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          message: '身份证号格式不对',
          trigger: 'blur'}]
      },
      ispopindex: '',
      exshow: false,
      skillshow: false,
      isdisabled: false,
      isPhone: false, // 是否是PC端/移动端
      screenWidth: 0 // 屏幕分辨率
    }
  },
  created () {
  },
  mounted () {
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth < 768) {
      this.isPhone = true
    } else {
      this.isPhone = false
    }
    let _this = this
    window.onresize = () => {
      _this.screenResize()
    }
  },
  methods: {
    // 获取地址栏参数
    getQueryStringRegExp (name) {
      var reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
      if (reg.test(location.href)) {
        return unescape(RegExp.$2.replace(/\+/g, ' '))
      } else {
        return ''
      }
    },
    // 失焦时触发
    blurFun () {
      setTimeout(function () {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 300)
    },
    popshow (val) {
      this.$refs.pop.style.display = 'block'
      this.ispopindex = val
    },
    // 成长验证
    experiencefun () {
      if (this.dataForm.experience === '') {
        this.exshow = true
      } else {
        this.exshow = false
        this.$refs.pop.style.display = 'none'
      }
    },
    // 个人技能验证
    skillfun () {
      if (this.dataForm.skill === '') {
        this.skillshow = true
      } else {
        this.skillshow = false
        this.$refs.pop.style.display = 'none'
      }
    },
    // 确定提交
    confirmbtn () {
      this.isdisabled = true
      setTimeout(() => {
        this.isdisabled = false
      }, 2000)
      this.$refs['volunteer'].validate(valid => {
        if (valid) {
          this.dataForm.phoneNumber = this.$cookie.get('phoneNumber')
          this.$http({
            url: this.$http.adornUrl(`/api/volunteer/web/volunteer/info?museumCode=${this.$route.query.museumCode}`),
            method: 'post',
            data: this.dataForm
          }).then((res) => {
            if (res) {
              if (res.data.rel === true) {
                this.isdisabled = false
                this.$message({
                  message: res.data.data,
                  type: 'success'
                })
                setTimeout(() => {
                  this.$router.push({path: '/volunteermuseum', query: {museumCode: this.$cookie.get('museumCode')}})
                }, 2000)
              } else {
                this.$message.error(res.data.data)
              }
            } else {
              this.$message.error(res.data.data)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
  *{-webkit-overflow-scrolling:touch;}
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .disabled{
    pointer-events: none;
    cursor: default;
    opacity: 0.6;
  }
  .addvolunteercon{
    padding: 20px;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    overflow-y: auto;
    .additem{
      background: #fff;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      padding: 0 16px;
      margin-bottom: 20px;
      .pubtitle{
        font-size: 18px;
        height: 46px;
        line-height: 46px;
        i{
          display: inline-block;
          float: right;
          width: 8px;
          height: 15px;
          background: url("../assets/images/icon-arrow-right.png") no-repeat;
          background-size: 100% 100%;
          position: relative;
          top: 16px;
        }
      }
      .personul{
        border-top: solid 1px #f1f1f1;
        padding: 20px 0px 30px;
        li{
          position: relative;
          line-height: 24px;
          margin-bottom: 20px;
          &:last-child{
            margin-bottom: 0;
          }
          i{
            display: inline-block;
            width: 18px;
            height: 18px;
            vertical-align: middle;
            margin-right: 5px;
            position: relative;
            top: -1px;
          }
          .lileft{
            position: absolute;
            top: 0;
            left: 0;
            width: 100px;
            i{
              background: url("../assets/images/icon-name.png") no-repeat;
              background-size: 100% 100%;
              &.icon-sex{
                background: url("../assets/images/icon-sex.png") no-repeat;
                background-size: 100% 100%;
              }
              &.icon-nickName{
                background: url("../assets/images/icon-nickName.png") no-repeat;
                background-size: 100% 100%;
              }
              &.icon-email{
                background: url("../assets/images/icon-email.png") no-repeat;
                background-size: 100% 100%;
              }
              &.icon-school{
                background: url("../assets/images/icon-school.png") no-repeat;
                background-size: 100% 100%;
              }
              &.icon-major{
                background: url("../assets/images/icon-major.png") no-repeat;
                background-size: 100% 100%;
              }
              &.icon-place{
                background: url("../assets/images/icon-place.png") no-repeat;
                background-size: 100% 100%;
              }
              &.icon-phoneNumber{
                background: url("../assets/images/icon-phoneNumber.png") no-repeat;
                background-size: 100% 100%;
              }
              &.icon-code{
                background: url("../assets/images/icon-code.png") no-repeat;
                background-size: 100% 100%;
              }
            }
            span{
              font-size: 16px;
              display: inline-block;
              height: 24px;
              width: 70px;
              text-align: justify;
              vertical-align: top;
              &::after {
                display: inline-block;
                width: 100%;
                content: "";
                height: 0;
              }
            }
          }
          .el-form-item{
            margin: 0 0 0 100px;
            border-bottom: solid 1px #f1f1f1;
            position: relative;
            .el-form-item__content{
              line-height: 24px;
              .el-input__inner{
                height: 24px;
                line-height: 24px;
                text-align: right;
                border: none!important;
                font-size: 14px;
                color: #666666;
              }
            }
            .el-select{
              width: 100%;
              .el-input__suffix{
                right: 8px;
                .el-input__icon{
                  line-height: 1;
                }
                i{
                  margin-right: 0;
                }
              }
            }
            &.code{
              .getcode{
                position: absolute;
                height: 24px;
                line-height: 26px;
                padding: 0 15px;
                right: 0px;
                letter-spacing: 2px;
                top: 0px;
                background: #c5c5c5;
                color: #fff;
                -webkit-border-radius: 4px;
                -moz-border-radius: 4px;
                border-radius: 4px;
                text-align: center;
                font-size: 12px;
                z-index: 2;
                i{
                  margin-right: 2px;
                  line-height: 18px;
                }
              }
              .el-input__inner{
                padding: 0 58% 0 5px;
                text-align: left;
              }
            }
          }
        }
      }
    }
    .pop{
      background: rgba(0,0,0,0.4);
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: none;
      z-index: 3;
      .popbox{
        display: table;
        overflow: hidden;
        width: 100%;
        height: 100%;
        .popinner{
          display: table-cell;
          vertical-align:middle;
          padding: 0 20px;
          .content{
            background: #fff;
            overflow: hidden;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            border-radius: 4px;
            padding: 0 0 30px;
            display: none;
            &.on{
              display: block;
            }
            .title{
              background: -webkit-linear-gradient(left, #7b0000 , #ef6161); /* Safari 5.1 - 6.0 */
              background: -o-linear-gradient(right, #7b0000, #ef6161); /* Opera 11.1 - 12.0 */
              background: -moz-linear-gradient(right, #7b0000, #ef6161); /* Firefox 3.6 - 15 */
              background: linear-gradient(to right, #7b0000 , #ef6161); /* 标准的语法 */
              filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#7b0000, endColorstr=#ef6161);
              height: 46px;
              line-height: 46px;
              text-align: center;
              font-size: 18px;
              color: #fff;
            }
            .con{
              padding: 20px 20px 0;
              .el-textarea__inner{
                min-height: 300px!important;
                border: none!important;
              }
              .volunteerposition{
                text-align: center;
                li{
                  display: inline-block;
                  width: 40%;
                  padding: 0 10px;
                  margin: 0 10px;
                  height: 32px;
                  line-height: 32px;
                  &.on{
                    border: solid 1px #a90a1a;
                    -webkit-border-radius: 4px;
                    -moz-border-radius: 4px;
                    border-radius: 4px;
                  }
                }
              }
              .item{
                margin-top: -10px;
                .el-form-item{
                  margin-bottom: 0px;
                }
                h2{
                  color: #a90a1a;
                  font-size: 16px;
                  margin: 20px 0 15px;
                }
                .el-checkbox-group{
                  line-height: 24px;
                }
                .el-checkbox{
                  line-height: 24px;
                  .el-checkbox__input.is-checked+.el-checkbox__label{
                    color: #a90a1a!important;
                  }
                  .el-checkbox__input.is-checked .el-checkbox__inner{
                    background-color: #a90a1a;
                    border-color: #a90a1a;
                  }
                }
              }
              .el-radio-group{
                width: 100%;
                .el-radio{
                  width: 40%;
                  display: inline-block;
                  margin: 5px 3% 5px 0;
                  height: 30px;
                  line-height: 30px;
                  text-align: center;
                  border: solid 1px #fff;
                  -webkit-border-radius: 4px;
                  -moz-border-radius: 4px;
                  border-radius: 4px;
                  .el-radio__inner{
                    display: none;
                  }
                  &.is-checked{
                    border: solid 1px #a90a1a;
                    .el-radio__label{
                      color: #a90a1a;
                      padding-left: 0;
                    }
                  }
                }
              }
            }
            .pubbutton{
              margin-top: 20px;
            }
          }
        }
      }
    }
    &.pc{
      padding: 0;
      overflow-y: hidden;
      .el-form{
        position: absolute;
        top: 90px;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 30px 0 60px;
        overflow: hidden;
        overflow-y: auto;
        .container{
          width: 800px;
        }
      }
      .pubbutton{
        width: 20%;
      }
      .pop{
        .popbox{
          width: 40%;
          margin: 0 auto;
          .pubbutton{
            width: 32%;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/volunteerinfo.vue